import React, { useEffect } from "react";
import { Button, message } from "antd";
import { YhBox } from "../../../../components2/YhBox";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { IHistoryDetail } from "../dataHistoryTypes";
import { useHistoryModel } from "../dataHistoryModel"
import { DetailType } from "../../../../types/FmsEnums";
import { useNavModel } from "../../../../model/navModel";
import { globalPrompt } from "../../../../components2/YhMessage"

const HistoryList = () => {
    const { dataSource, page, selectedRowKeys, selectedRow, loadData, setSelectedRowKeys, setSelectedRow } = useHistoryModel()
    const { addNav } = useNavModel()

    useEffect(() => {
        loadData()
    }, [])
    const columns: ColumnsType<IHistoryDetail> = [
        {
            title: '序号',
            render: (text, record, index) => `${index + 1}`
        },
        {
            title: '编码',
            dataIndex: 'code',
        },
        {
            title: '执行编码',
            dataIndex: 'changeCode',
        },
        {
            title: '数据目录编码',
            dataIndex: 'catalog',
        },
        {
            title: '分支编码',
            dataIndex: 'branch',
        },
        {
            title: '数据编码',
            dataIndex: 'dataCode',
        },
        {
            title: '数据版本',
            dataIndex: 'dataVer',
        },
    ];
    const onDetail = (type: string) => {
        const id = selectedRowKeys[0] as string //这里做类型转换

        switch (type) {
            case DetailType.look:
                if (selectedRowKeys.length == 0) return globalPrompt("message", { type: "error", text: "选择您要查看的数据" })
                return addNav("1-4-3", { id, mode: type });
            default:
                return false
        }
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => onDetail("look")}
        >查看</Button>
    </>
    const rowSelection = {
        onChange(selectedRowKeys: React.Key[], selectedRows: IHistoryDetail[]) {
            setSelectedRowKeys(selectedRowKeys)
        },
        selectedRowKeys
    }
    const onRow = (record: IHistoryDetail) => {
        return {
            onClick: () => {
                if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.code) {
                    setSelectedRowKeys([])
                    setSelectedRow({})
                } else {
                    setSelectedRowKeys([record.code as string])
                    setSelectedRow(record)
                }
            },
        }
    }
    return (
        <YhBox action={action}>
            <Table
                columns={columns}
                rowKey={(record: any) => record.code}
                dataSource={dataSource}
                rowSelection={{
                    type: "radio",
                    ...rowSelection
                }}
                onRow={onRow}
                pagination={{
                    ...page,
                    position: ["bottomCenter"],
                    showTotal: () => `共${page.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    }
                }}
            />
        </YhBox>
    )
}
export default HistoryList